import { type IInsightTagRef } from "~/feature/insights/types";

export const mergeInsightTags = (
  primaryTag: IInsightTagRef | null | undefined,
  tags: IInsightTagRef[] | null | undefined
): IInsightTagRef[] => {
  const merged: IInsightTagRef[] = [];
  const seen = new Set<string>();

  if (primaryTag?.slug) {
    merged.push(primaryTag);
    seen.add(primaryTag.slug);
  }

  for (const tag of tags ?? []) {
    if (!seen.has(tag.slug)) {
      merged.push(tag);
      seen.add(tag.slug);
    }
  }

  return merged;
};
